import * as React from 'react';
import Equalizer from 'react-equalizer';
import IBike from '../interfaces/IBike';
import IPagination from '../interfaces/IPagination';
import { translate, translateReplace, translateReplacePlural } from 'PyzShopUi/scripts/utils/translate';
import { numberFormat } from '../../common/lib';
import { IViewOption } from '../../common/components/layout/view-options/ViewOptions';
import { IBikeItem } from 'PyzShopUi/scripts/bike/interfaces';

interface IBikeGridProps {
    bikes: IBike[] | IBikeItem[];
    viewOptions?: IViewOption;
    placeholderImage?: string;
    hasSideBar: boolean;
    csrfToken: string;

    onRemove?(bikeId: string): void;
}

interface IMyBikeListProps {
    imageEmptyMyBikeUrl: string;
    placeholderImage: string;
    pagination: IPagination;
    bikes: IBike[] | IBikeItem[];
    totalBikes: number;
    bikeGridComponent: React.FunctionComponent;
    bikeDatabaseUrl: string;
    hasSideBar: boolean;
    csrfToken: string;

    onRemove?(bikeId: string): void;
}

const MyBikeList: React.FunctionComponent<IMyBikeListProps> = props => {
    const isBikeListShown = props.pagination.totalItems > 0;
    const BikeGridComponent: React.FunctionComponent<IBikeGridProps> = props.bikeGridComponent;

    const displayContent = () => {
        const totalBikes = props.totalBikes <= 100 ? Math.floor((props.totalBikes) / 10) * 10 : Math.floor((props.totalBikes) / 100) * 100;

        return (
            <React.Fragment>
                <div className={`grid-x grid-margin-x ${!isBikeListShown ? 'hide' : ''}`}>
                    <div className='cell small-12 bike-list-content-header'>
                        <div className='bike-items-count bold'>
                            {translateReplacePlural('{{total}} bike', props.pagination.totalItems, { total: numberFormat(props.pagination.totalItems) }, 'bike-db')}
                        </div>
                    </div>
                    <BikeGridComponent
                        bikes={props.bikes}
                        placeholderImage={props.placeholderImage}
                        onRemove={props.onRemove}
                        hasSideBar={props.hasSideBar}
                        csrfToken={props.csrfToken}
                    />
                </div>

                <div className={'empty-my-bike' + (isBikeListShown ? ' hide' : '')}>
                    <img src={props.imageEmptyMyBikeUrl} />
                    <h1>{translate('My bike and the Louis Bike Database', 'bike-db')}</h1>
                    <p suppressHydrationWarning={true}>
                        {translateReplace('Our Bike Database contains more than {{totalBikes}} models:', { totalBikes: numberFormat(totalBikes) }, 'bike-db')}&nbsp;
                        {translate('model-specific wearing parts and accessories...', 'bike-db')}&nbsp;
                        {translate('Save your vehicles and „My bike“...', 'bike-db')}
                    </p>
                    <p>{translate('You can also permanently transfer your vehicle selection into...', 'bike-db')}</p>
                </div>
            </React.Fragment>
        );
    };

    const bikeImageLinks = (_, equalizerElement) => equalizerElement.getElementsByClassName('bike-image-link');

    return (
        <div className='grid-x grid-margin-x' data-scroll-to-offset='true'>
            <div className='cell small-12 medium-3' suppressHydrationWarning={true}>
                <a className='button button-red mdc--fullwidth button-find-your-bike' href={props.bikeDatabaseUrl}>
                    <span className='mdc--fullwidth text-center'>{translate('Find your bike', 'bike-db')}</span>
                    <i className='icon icon-mein-bike'/>
                </a>
            </div>

            <Equalizer
                className='cell small-12 medium-9'
                byRow={false}
                nodes={bikeImageLinks}
                suppressHydrationWarning={true}
            >
                {displayContent()}
            </Equalizer>
        </div>
    );
};

export default MyBikeList;
